import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import AppUtils from '../../control/apputlis';

class NewsDetail extends React.Component {
    constructor(props) {
        super(props);

        console.log('NewsDetail', props);

        let data = props.location.data;
        if (!data) {
            data = AppUtils.getStorageObj('NewsDetail');
        }
        AppUtils.setStorageObj('NewsDetail', data)

        this.state = {
            news: data,
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'MoreRecomm');
        // this.getNewsDetail();
        const { news } = this.state;
        document.getElementById('contentdiv').innerHTML = news.content;
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    // getNewsDetail = async () => {
    //     const { id } = this.props.match.params;
    //     let result = await Apis.encryptionNewsContent(id);
    //     console.log('getNewsDetail', result);
    //     if (result.code == 200) {
    //         this.setState({ news: result.data });
    //         document.getElementById('contentdiv').innerHTML = result.data.content;
    //     }
    // }


    render() {
        const { classes } = this.props;
        const { news } = this.state;
        let title = news ? AppUtils.getSubString(news.title, 8) : '新闻';
        return (
            <MBack title={title}>
                <Grid className={classes.content}>
                    <Grid container justify='center' className={classes.titleView}>
                        <Typography style={{ color: '#0D0D0D', fontSize: 17, fontWeight: 'bold' }}>{news && news.title}</Typography>
                    </Grid>
                    <div id='contentdiv' className={classes.fontContent}></div>
                </Grid>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({

    content: {
        width: '100vw',
        alignItems: 'center',
    },
    titleView: {
        marginTop: 16,
        padding: theme.spacing(2, 1, 2, 1),
    },
    fontContent: {
        width: '94vw',
        padding: theme.spacing(2, 1, 2, 1),
        overflowX: 'scroll',
    }
}))(NewsDetail));